import { ADR_EDIT, CEM4907 } from "../_constants/actionConstants";
import axios from "axios";
import _ from "lodash";
import { BASE_URL } from "../_constants/urlConstants";
import qs from "qs";
import pdfActions from "./pdfActions";

const request = (cem4907Data) => async (dispatch) => {
  dispatch({ type: CEM4907.REQUEST });

  let res;
  if (cem4907Data.pdfFilePath) {
    const apiEndpoint_get =
      BASE_URL + "/api/Cem4907Pdf/Get/?pdfFilePath=" + cem4907Data.pdfFilePath;
    try {
      res = await axios.get(apiEndpoint_get, { responseType: "blob" });
      dispatch({ type: CEM4907.REQUEST_FULFILLED });
    } catch (e) {
      dispatch({ type: CEM4907.REQUEST_REJECTED });
      return Promise.reject(e);
    }
  } else {
    try {
      const apiEndpoint_create = BASE_URL + "/api/Cem4907Pdf/Create/";
      const pdfServiceOk = await dispatch(pdfActions.testService());
      if (!pdfServiceOk) throw new Error("PDF Service is offline.");

      res = await axios.post(apiEndpoint_create, cem4907Data, { responseType: "blob" });
      dispatch({ type: CEM4907.REQUEST_FULFILLED });
    } catch (e) {
      // network/server error...
      dispatch({ type: CEM4907.REQUEST_REJECTED });
      return Promise.reject(e);
    }
  }

  if (res && res.data) {
    const fileName = res.headers["content-disposition"]
      .split("filename=")[1]
      .split(";")[0]
      .trim();
    const pdfFileBlob = new Blob([res.data], { type: "application/pdf" });

    const url = URL.createObjectURL(pdfFileBlob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  return Promise.resolve();
};

const requestFromDb = (tentativeAgreementId) => async (dispatch) => {
  dispatch({ type: CEM4907.REQUEST });

  const apiEndpoint_create = BASE_URL + "/api/Cem4907Pdf/CreateFromDB/";
  try {
    const pdfServiceOk = await dispatch(pdfActions.testService());
    if (!pdfServiceOk) throw new Error("PDF Service is offline.");
    const fileRes = await axios.get(apiEndpoint_create, {
      params: { tentativeAgreementId },
      paramsSerializer: (params) => qs.stringify(params),
      responseType: "blob",
    });
    dispatch({ type: CEM4907.REQUEST_FULFILLED });

    // File is streamed back only for preview requests. Non-preview
    // requests only show PDF save success alert.
    if (fileRes.data) {
      const fileName = fileRes.headers["content-disposition"]
        .split("filename=")[1]
        .split(";")[0]
        .trim();
      const pdfFileBlob = new Blob([fileRes.data], { type: "application/pdf" });

      const url = URL.createObjectURL(pdfFileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
    return;
  } catch (err) {
    // If error, do not show error msg, to allow re-attempt of client-side
    // PDF generation.
    dispatch({ type: CEM4907.REQUEST_REJECTED });
    console.error("PDF could not be processed by the server.", err);
    return Promise.reject(err);
  }
};

const sendTentativeAgreementEmail =
  (tentativeAgreementId, emailTo) => async (dispatch) => {
    dispatch({ type: ADR_EDIT.TENTATIVE_AGREEMENTS.SEND_EMAIL });
    const apiEndpoint = `${BASE_URL}/api/Cem4907Pdf/Send/${tentativeAgreementId}/ViaEmail`;
    try {
      const res = await axios.post(apiEndpoint, emailTo);
      dispatch({ type: ADR_EDIT.TENTATIVE_AGREEMENTS.SEND_EMAIL_FULFILLED });
    } catch (e) {
      dispatch({ type: ADR_EDIT.TENTATIVE_AGREEMENTS.SEND_EMAIL_REJECTED });
    }
  };

const cem4907PdfActions = {
  request,
  requestFromDb,
  sendTentativeAgreementEmail,
};

export default cem4907PdfActions;
